import {useRouter} from "next/router";
import React, {useEffect, useState} from "react";
import {AB_PREFERRED_COOKIE, AB_VARIANTS} from "@/constants";
import JsCookies from "js-cookie";
import {Tag} from "@/components/common/Preview/Tag";
import Text from "@/components/common/Text";

const ABVariantButton = ({  }) => {
	const router = useRouter()
	const [variant, setVariant] = useState(AB_VARIANTS.A)
	const onButtonClick = () => {
		const v = variant === AB_VARIANTS.A ? AB_VARIANTS.B : AB_VARIANTS.A
		JsCookies.set(AB_PREFERRED_COOKIE, v, { expires: 365 });
		setVariant(v)
		router.replace(router.asPath);
	}

	useEffect(() => {
		const prefCookie = JsCookies.get(AB_PREFERRED_COOKIE)
		setVariant(prefCookie)
	}, []);

	return (
		<Tag onClick={onButtonClick}>
			<Text color="white">
				Aktualny wariant: {variant}
			</Text>
			<Text color="white">
				Kliknij aby przełaczyć
			</Text>
		</Tag>
	)
}

export default ABVariantButton
